import type { CreateServerData } from '../api/whatsapp-servers.service';

export function emptyServerForm(): CreateServerData {
  return {
    name: '',
    baseUrl: '',
    adminApiKey: '',
    maxCapacity: 300,
    region: '',
    priority: 0,
    notes: '',
    isActive: true,
  };
}
